import * as React from 'react'
import * as styles from './PagePreviewTiles.module.scss'
import { PagePreviewTile } from './PagePreviewTile'
import { IPagePreviewTiles } from './PagePreviewTiles.types'

export const PagePreviewTiles: React.FC<IPagePreviewTiles> = ({ tiles, defaultTileImage, root, saveState }) => (
  <div className={styles.pressContainer}>
    {tiles?.map((item, index) => (
      <PagePreviewTile content={item} defaultTileImage={defaultTileImage} key={index} root={root} saveState={saveState} />
    ))}
  </div>
)
